import React, { useState, useEffect, useCallback } from 'react'
import Navigation from './components/navigation/Navigation'
import IntroAnimation from './components/intro/IntroAnimation'
import useGlobalReveal from './utils/useGlobalReveal'
import './App.css'

const App = () => {
  // Only show intro if not already seen this session
  const [showIntro, setShowIntro] = useState(
    () => !sessionStorage.getItem('sipl_intro_seen')
  )

  const handleIntroComplete = useCallback(() => {
    sessionStorage.setItem('sipl_intro_seen', '1')
    setShowIntro(false)
  }, [])

  // Safety fallback: Never allow any intro animation to hang or delay page display beyond 2.2s
  useEffect(() => {
    if (!showIntro) return
    const safetyTimer = setTimeout(() => {
      handleIntroComplete()
    }, 2200)
    return () => clearTimeout(safetyTimer)
  }, [showIntro, handleIntroComplete])

  // Global scroll reveal with smooth top-to-bottom delay across all content
  // Starts when the intro completes (or immediately if already seen)
  useGlobalReveal(!showIntro)

  return (
    <>
      {showIntro && <IntroAnimation onComplete={handleIntroComplete} />}
      <div
        className={`sipl-app-root ${showIntro ? 'sipl-app-fade-in-pending' : 'sipl-app-fade-in-ready'
          }`}
      >
        <Navigation />
      </div>
    </>
  )
}

export default App